module.exports = __webpack_public_path__ + "06dbf901b7e7eade9354db6836d64a3f.MP3";